import { render, staticRenderFns } from "./viewOwnerInfo.vue?vue&type=template&id=189bafdd&scoped=true"
import script from "./viewOwnerInfo.vue?vue&type=script&lang=js"
export * from "./viewOwnerInfo.vue?vue&type=script&lang=js"
import style0 from "./viewOwnerInfo.vue?vue&type=style&index=0&id=189bafdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189bafdd",
  null
  
)

export default component.exports